module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shopperApprovalMap",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n          ×\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('GoogleMaps', {
    ref: "approvalGmaps",
    attrs: {
      "checkList": _vm.checkList,
      "proposalList": _vm.proposalList,
      "currentFilterObject": null
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33283bf9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShopperApproval/ShopperApprovalMap.vue
// module id = 1667
// module chunks = 1